// Key cap: 18 px, mono 12, inset (CONTRACT "Controls"). Numbered caps at row
// ends use tone "num" (ink instead of muted).
import { cx } from './cx';
import './KeyCap.css';

export interface KeyCapProps {
  readonly children: string;
  readonly tone?: 'muted' | 'num';
  readonly className?: string;
}

export function KeyCap({ children, tone = 'muted', className }: KeyCapProps) {
  return (
    // role="img" because aria-label is prohibited on a bare kbd: the cap reads
    // as "Key t" rather than as the bare letter, and axe stops reporting the
    // prohibited attribute (redo-1 fix round 2, P1).
    <kbd role="img" className={cx('kc', tone === 'num' && 'kc-num', className)} aria-label={`Key ${children}`}>
      {children}
    </kbd>
  );
}
